import React from 'react';

const CircuitAnimation: React.FC = () => {
  return (
    <div className="absolute inset-0 overflow-hidden pointer-events-none">
      <div className="absolute w-[200%] h-[200%] -translate-x-1/4 -translate-y-1/4 -z-20 opacity-60">
        <svg width="100%" height="100%" viewBox="0 0 2000 2000" preserveAspectRatio="xMidYMid slice">
          {/* Cesty vycházející ze středu s 45° úhly */}
          <path d="M1000,1000 L1100,900 L1300,900 L1400,800 L1600,800 L1700,700 L1900,700" 
                fill="none" stroke="#3fe0d0" strokeWidth="3" strokeDasharray="5,5" />
          
          <path d="M1000,1000 L1100,1100 L1300,1100 L1400,1200 L1600,1200 L1700,1300 L1900,1300" 
                fill="none" stroke="#3fe0d0" strokeWidth="3" strokeDasharray="5,5" />
          
          <path d="M1000,1000 L900,1100 L900,1300 L800,1400 L800,1600 L700,1700 L700,1900" 
                fill="none" stroke="#3fe0d0" strokeWidth="3" strokeDasharray="5,5" />
          
          <path d="M1000,1000 L900,900 L900,700 L800,600 L800,400 L700,300 L700,100" 
                fill="none" stroke="#3fe0d0" strokeWidth="3" strokeDasharray="5,5" />
          
          <path d="M1000,1000 L1100,900 L1300,700 L1400,600 L1600,400 L1700,300 L1900,100" 
                fill="none" stroke="#3fe0d0" strokeWidth="3" strokeDasharray="5,5" />
          
          <path d="M1000,1000 L900,1100 L700,1300 L600,1400 L400,1600 L300,1700 L100,1900" 
                fill="none" stroke="#3fe0d0" strokeWidth="3" strokeDasharray="5,5" />
          
          {/* Dodatečné diagonální cesty */}
          <path d="M1000,1000 L1100,1100 L1200,1200 L1300,1300 L1400,1400 L1600,1600 L1800,1800" 
                fill="none" stroke="#3fe0d0" strokeWidth="3" strokeDasharray="5,5" />
          
          <path d="M1000,1000 L900,900 L800,800 L700,700 L600,600 L400,400 L200,200" 
                fill="none" stroke="#3fe0d0" strokeWidth="3" strokeDasharray="5,5" />
          
          {/* Definice cest pro animace */}
          <defs>
            <path id="path1" d="M1000,1000 L1100,900 L1300,900 L1400,800 L1600,800 L1700,700 L1900,700" />
            <path id="path2" d="M1000,1000 L1100,1100 L1300,1100 L1400,1200 L1600,1200 L1700,1300 L1900,1300" />
            <path id="path3" d="M1000,1000 L900,1100 L900,1300 L800,1400 L800,1600 L700,1700 L700,1900" />
            <path id="path4" d="M1000,1000 L900,900 L900,700 L800,600 L800,400 L700,300 L700,100" />
            <path id="path5" d="M1000,1000 L1100,900 L1300,700 L1400,600 L1600,400 L1700,300 L1900,100" />
            <path id="path6" d="M1000,1000 L900,1100 L700,1300 L600,1400 L400,1600 L300,1700 L100,1900" />
            <path id="path7" d="M1000,1000 L1100,1100 L1200,1200 L1300,1300 L1400,1400 L1600,1600 L1800,1800" />
            <path id="path8" d="M1000,1000 L900,900 L800,800 L700,700 L600,600 L400,400 L200,200" />
          </defs>
          
          {/* Animovaná kolečka */}
          <circle r="8" fill="#3fe0d0">
            <animateMotion dur="8s" repeatCount="indefinite" begin="0s">
              <mpath href="#path1" />
            </animateMotion>
          </circle>
          
          <circle r="8" fill="#3fe0d0">
            <animateMotion dur="10s" repeatCount="indefinite" begin="1s">
              <mpath href="#path2" />
            </animateMotion>
          </circle>
          
          <circle r="8" fill="#3fe0d0">
            <animateMotion dur="9s" repeatCount="indefinite" begin="2s">
              <mpath href="#path3" />
            </animateMotion>
          </circle>
          
          <circle r="8" fill="#3fe0d0">
            <animateMotion dur="11s" repeatCount="indefinite" begin="0.5s">
              <mpath href="#path4" />
            </animateMotion>
          </circle>
          
          <circle r="8" fill="#3fe0d0">
            <animateMotion dur="9s" repeatCount="indefinite" begin="3s">
              <mpath href="#path5" />
            </animateMotion>
          </circle>
          
          <circle r="8" fill="#3fe0d0">
            <animateMotion dur="10s" repeatCount="indefinite" begin="2.5s">
              <mpath href="#path6" />
            </animateMotion>
          </circle>
          
          <circle r="8" fill="#3fe0d0">
            <animateMotion dur="12s" repeatCount="indefinite" begin="1.5s">
              <mpath href="#path7" />
            </animateMotion>
          </circle>
          
          <circle r="8" fill="#3fe0d0">
            <animateMotion dur="9s" repeatCount="indefinite" begin="0.2s">
              <mpath href="#path8" />
            </animateMotion>
          </circle>
        </svg>
      </div>
    </div>
  );
};

export default CircuitAnimation; 